<template>
    <SOSlotBase
        :bg-grey="true"
        :is-search="isSearch"
    >
        <template v-slot:title-bar>
            <SOTitleBar
                :page-title="'Template WA Blast'"
                :show-search="true"
                :type="'back'"
                @back="back"
                @search="openSearchTemplate"
            />
        </template>

        <template v-slot:search-bar>
            <SOSearchBar
                v-if="isSearch"
                :context="'Template WA Blast'"
                :placeholder="`Ketik minimal 2 karakter`"
                :value="search"
                :data-count="totalTemplate"
                :search-information="`Nama template`"
                :waiting="searchLoading"
                @return-search-value="(v) => { setSearchTemplate(v) }"
                @do-search="(v) => doSearchTemplate({key: v})"
                @loading="loadingSearchTemplate"
                @close="closeSearchTemplate"
            />
        </template>

        <template v-slot:empty-state>
            <SOEmptyState
                v-if="listNullNoSearch"
                :message="'Belum pernah membuat Template WA Blast'"
                :sub-message="'Klik tombol + untuk membuat template'"
            />
            <SOEmptySearchState
                v-if="listNullSearch"
                @action="setSearch('')"
            />
        </template>

        <template v-slot:skeleton>
            <div class="p-x-20 p-y-12" v-if="isFetching">
                <SOCardTransaksiSkeleton/>
            </div>
        </template>

        <template v-slot:content>
            <div class="p-x-20 p-y-16">
                <SOHeaderList
                    v-if="!listNull && !isFetching"
                    class="p-d-16"
                    :title="`${totalTemplate} Template`"
                />

                <CardTemplatePesanBlast :data-list="listTemplate"/>

                <SOFABRegular @add="addTemplate"/>
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {moduleName} from "./../store/state";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOCardTransaksiSkeleton from "@/so-components/modules/transaksi/reguler/SOCardTransaksiSkeleton";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import CardTemplatePesanBlast from "@/modules/wa-blast/components/CardTemplatePesanBlast";
import SOFABRegular from "@/so-components/global/ui/SOFABRegular";

export default {
    name: "WABlastTemplatePesanList",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOSearchBar,
        SOEmptyState,
        SOEmptySearchState,
        SOCardTransaksiSkeleton,
        SOHeaderList,
        CardTemplatePesanBlast,
        SOFABRegular,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            endItemofPage: "endItemofPage",
            displayItem: "displayItem",
            listTemplate: "listTemplate",
            totalTemplate: "totalTemplate",

            search: "search",
            searchLoading: "searchLoading",
            isSearch: "isSearch",
            blastType: "blastType",
        }),
        listNull() {
            return this.totalTemplate === 0 && !this.isFetching
        },
        listNullNoSearch() {
            return this.listNull && !this.isSearch
        },
        listNullSearch() {
            return this.listNull && this.isSearch && !this.searchLoading && this.search.length > 2
        }
    },
    mounted() {
        this.init();
        this.scrollTo();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path.split("/")[1] !== "wa-blast" && from.path.split("/")[1] !== "template-pesan") {
                vm.resetListTemplate()
                vm.resetPaginationTemplate()
            }
        })
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== "dashboard") {
            this.setLastItem();
        }
        next();
    },
    data() {
        return {
            jenis: null,
        }
    },
    methods: {
        ...mapActions({
            fetchListTemplate: `${moduleName}/fetchListTemplate`,

            setEndItemofPage: `${moduleName}/setEndItemofPage`,
            resetPaginationTemplate: `${moduleName}/resetPaginationTemplate`,
            resetListTemplate: `${moduleName}/resetListTemplate`,
            openSearchTemplate: `${moduleName}/openSearchTemplate`,
            closeSearchTemplate: `${moduleName}/closeSearchTemplate`,
            setSearchTemplate: `${moduleName}/setSearchTemplate`,
            loadingSearchTemplate: `${moduleName}/loadingSearchTemplate`,
            doSearchTemplate: `${moduleName}/doSearchTemplate`
        }),
        init() {
            this.getJenis();
            if (this.blastType != this.jenis) {
                this.$store.commit(`${moduleName}/setBlastType`, this.jenis);
                this.resetListTemplate()
            }
            if (this.listTemplate.length === 0) {
                this.resetPaginationTemplate();
                this.fetchListTemplate();
            }
        },
        scrollTo() {
            let el = document.getElementById(`card-${this.endItemofPage.id}`);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView();
                    document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
                }, 100);
            }
        },
        setLastItem() {
            let newDP = this.displayItem.sort(function(a, b) {
                if (a.yDir < b.yDir) {
                    return -1;
                }
                if (a.yDir > b.yDir) {
                    return 1;
                }
                return 0;
            });

            if (newDP[0]) {
                this.setEndItemofPage(newDP[0]);
            }
        },
        addTemplate() {
            this.$router.push({name: "wa_blast.template-pesan.create"})
        },
        back() {
            this.$router.back()
        },
        getJenis() {
            this.jenis = this.$route.query.jenis || null;
        },
    }
}
</script>